import React from 'react';
import './BusinessTutorials.css';
import BTHeadline from './BTHeadline/BTHeadline'
import TutorialVideo from '../../../Components/TutorialVideo/TutorialVideo'
import BusinessSupport from './BusinessSupport/BusinessSupport'
import { businessProfiles, services, ManagingPayments } from './data'
import Page from "../../Page/Page";
import SeoHelmet from '../../../Components/SeoHelmet/SeoHelmet';



const BusinessTutorials = () => {
    return (
        <Page>
            <SeoHelmet title="Business App Tutorials - Elite Partyz" keywords="Party, Elite Party, Event, Event manager, Tutorial" description="Video Tutorials Here are some simple how to videos on using the Elite Partyz app. See below videos on how to set up your profile, find suppliers, buy products, make payments ..." canonicalLink="/business-app-tutorials" />
            <div className="member-tutorial-page">
                <BTHeadline />
                <TutorialVideo sectionHeading={businessProfiles.videoHeading} videoData={businessProfiles.allVideo} />
                <TutorialVideo sectionHeading={services.videoHeading} videoData={services.allVideo} />
                <TutorialVideo sectionHeading={ManagingPayments.videoHeading} videoData={ManagingPayments.allVideo} />
                <BusinessSupport />
            </div>
        </Page>
    )
}

export default BusinessTutorials
